import { useEffect } from "react";
import Seo from "@/components/Seo";
import SarapeDivider from "@/components/SarapeDivider";
import NewsletterSignup from "@/components/NewsletterSignup";

const SORO_SRC = "https://app.trysoro.com/api/embed/0ee229e9-b0c7-4dc9-855e-9fb4ecd65c3e";

export default function Blog() {
  useEffect(() => {
    window.scrollTo(0, 0);
    // The Soro embed renders into #soro-blog. Re-inject the script on each mount
    // so it re-renders when navigating back to this page in the SPA.
    document.querySelectorAll(`script[src="${SORO_SRC}"]`).forEach((el) => el.remove());
    const script = document.createElement("script");
    script.src = SORO_SRC;
    script.defer = true;
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <div data-testid="page-blog">
      <Seo
        title="Resources & Stories"
        description="Honest guides, tips, and stories about moving from the US to Mexico — with a focus on Mérida, Yucatán."
        path="/blog"
      />
      {/* Hero */}
      <section className="relative overflow-hidden bg-sand-100">
        <div className="absolute inset-0 pattern-talavera opacity-[0.05]" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-12 py-20 lg:py-28">
          <p className="text-sm uppercase tracking-[0.2em] text-clay-700 font-medium mb-4">Resources & stories</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-charcoal-900 leading-[1.05] max-w-3xl">
            Guidance for your move, one read at a time.
          </h1>
          <p className="mt-6 text-lg text-charcoal-600 leading-relaxed max-w-2xl">
            Honest, practical articles about relocating from the US to Mexico — what to expect, how to prepare, and stories from the road.
          </p>
        </div>
      </section>
      <SarapeDivider />

      <div className="mx-auto max-w-7xl px-6 lg:px-12 py-16 lg:py-24 min-h-[40vh]">
        <div id="soro-blog" data-testid="soro-blog-embed" />
      </div>

      <NewsletterSignup source="blog" />
    </div>
  );
}
